import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import CommonPopup from 'components/common/CommonPopup';
import TooltipCommon from 'components/common/TooltipCommon';
import TooltipButton from 'components/elements/buttons/TooltipButton';

import './FavoriteLinkAction.css';

class FavoriteLinkAction extends Component {
  static propTypes = {
    patchLink: PropTypes.func.isRequired,
    linkId: PropTypes.number.isRequired,
    priorityClass: PropTypes.bool,
  };

  static defaultProps = {
    priorityClass: null,
  };

  state = {
    firstChange:  null,
    currentPriorityClass: null,
    popupOpen: false,
  };

  componentDidMount() {
    this.setState({ currentPriorityClass: this.props.priorityClass });
  }

  componentDidUpdate(prevProps, prevState) {
    const { linkId, patchLink } = this.props;
    const { currentPriorityClass, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentPriorityClass !== this.state.currentPriorityClass
    ) {
      patchLink(linkId, { priority_class: currentPriorityClass });
    }

    if (prevProps.priorityClass !== this.props.priorityClass) {
      this.setState({ currentPriorityClass: this.props.priorityClass });
    }
  }

  onFavoriteHandle = value => {
    this.setState({
      firstChange: true,
      popupOpen: false,
    });

    if (this.state.currentPriorityClass === value) {
      this.setState({ currentPriorityClass: '' });
    } else {
      this.setState({ currentPriorityClass: value });
    }
  };

  onPopupClose = () => {
    this.setState({ popupOpen: false });
  };

  renderTooltipContent = () => {
    const { currentPriorityClass } = this.state;
    const effects = ['buzz', 'wobble', 'pop'];

    return (
      <div className="tooltip-content">
        <div className="buttons-block">
          {effects.map(item => (
            <div className="effect-item">
              <div className={`icon ${item}${item === currentPriorityClass ?
                ' active' : ''}`} />
              <TooltipButton
                negative={currentPriorityClass === item}
                key={`favorite-effect-button-key-${item}`}
                onClick={() => {
                  this.onFavoriteHandle(item);
                }}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </TooltipButton>
            </div>
          ))
          }
        </div>
      </div>
    )
  };

  renderFavoriteLinkActionButton = () => (
    <Translation>
      {(t) => (
        <div
          className={`favorite-link-action__component
            ${this.state.currentPriorityClass ? ' active' : ''}`}
          onClick={() => this.setState({ popupOpen: true })}
          role="button"
          tabIndex={-1}
        >
          <div className="icon-container">
            <div className="icon" />
          </div>
          <div className="undertext">{t("Effects")}</div>
        </div>
      )}
    </Translation>
  );

  render() {
    const { linkId } = this.props;

    return (
      <Translation>
        {(t) => (
          <TooltipCommon
            key={`favorite-link-tooltip-key-${linkId}`}
            overlayClassName="favorite-link-tooltip__component"
            header={t("Add special effects")}
            placement="bottom"
            trigger="click"
            visible={this.state.popupOpen}
            closeIcon
            onClose={this.onPopupClose}
            overlay={this.renderTooltipContent()}
          >
            <CommonPopup
              basic
              hideOnScroll
              wide="very"
              trigger={this.renderFavoriteLinkActionButton()}
              triggerClassName="favorite-link-tooltip__trigger"
            >
              {t("Add special effects")}
            </CommonPopup>
          </TooltipCommon>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    patchLinkError: state.linksReducer.patchLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLink,
  },
)(FavoriteLinkAction);
